/**
 * Success toast title for COS/AH invoice bulk actions and claim actions
 * (payload matches `changeNDISClaimCaseNoteInvoiceStatusRequest` / claim APIs).
 *
 * @param {{ status?: string; report?: string } | null | undefined} payload
 * @param {{ data?: { skipped_already_paid?: number; processed_count?: number }; skipped_already_paid?: number; processed_count?: number } | null | undefined} actionResult
 * @returns {string}
 */
export function getInvoiceActionSuccessToastTitle(payload, actionResult) {
  if (!payload || typeof payload !== "object") {
    return "Action completed successfully!";
  }

  const { status, report } = payload;
  const result = actionResult?.data ?? actionResult ?? {};
  const skipped = Number(result.skipped_already_paid) || 0;
  const processed = Number(result.processed_count) || 0;

  if (report === "pdf") {
    return "PDF generated successfully!";
  }
  if (report === "xlsx") {
    return "Excel file generated successfully!";
  }

  if (status === "provider_paid" || status === "paid") {
    if (processed === 0 && skipped > 0) {
      return "All selected case notes were already paid.";
    }
    if (skipped > 0 && processed > 0) {
      const processedLabel = processed === 1 ? "case note" : "case notes";
      const skipVerb = skipped === 1 ? "was" : "were";
      return `${processed} ${processedLabel} marked as paid. ${skipped} already paid and ${skipVerb} skipped.`;
    }
    return "Marked as paid successfully!";
  }

  switch (status) {
    case "revert":
      return "Reverted successfully!";
    case "cancelled":
      return "Cancelled successfully!";
    case "extract_generated":
    case "undo_cancel":
      return "Undo cancel applied successfully!";
    case "xero":
    case "Export to Xero":
      return "Exported to Xero successfully!";
    case "email_invoice":
      return "Email sent successfully!";
    default:
      return "Action completed successfully!";
  }
}
